import * as React from 'react';
import {forwardRef, FunctionComponent, MouseEvent, SVGProps} from 'react';

import {IconContainer} from './styled';

interface Props {
    className?: string;
    width?: number | string;
    height?: number | string;
    source: FunctionComponent<SVGProps<SVGSVGElement>>;
    block?: boolean;
    onClick?: (event: MouseEvent) => void;
    title?: string;
    fillColor?: string;
    strokeColor?: string;
    style?: React.CSSProperties;
}

export const Icon = forwardRef<HTMLSpanElement, Props>(
    (
        {
            className,
            width = 30,
            height = 30,
            block = false,
            onClick,
            source: Source,
            title,
            fillColor,
            strokeColor,
            style,
        },
        ref,
    ) => (
        <IconContainer
            ref={ref}
            className={className}
            block={block}
            onClick={onClick}
            title={title}
            fillColor={fillColor}
            strokeColor={strokeColor}
            style={style}
        >
            <Source width={width} height={height} />
        </IconContainer>
    ),
);
